
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function BottomNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const navItems = [
    {
      id: 'home',
      label: t('home'),
      icon: 'ri-home-line',
      activeIcon: 'ri-home-fill',
      path: '/home'
    },
    {
      id: 'orders',
      label: t('orders'),
      icon: 'ri-file-list-line',
      activeIcon: 'ri-file-list-fill',
      path: '/orders'
    },
    {
      id: 'booking',
      label: t('newTrip'),
      icon: 'ri-add-circle-line',
      activeIcon: 'ri-add-circle-fill',
      path: '/booking',
      isMain: true
    },
    {
      id: 'notifications',
      label: t('notifications'),
      icon: 'ri-notification-line',
      activeIcon: 'ri-notification-fill',
      path: '/notifications'
    },
    {
      id: 'profile',
      label: t('profile'),
      icon: 'ri-user-line',
      activeIcon: 'ri-user-fill',
      path: '/profile'
    }
  ];

  const isActive = (path: string) => {
    if (path === '/home') {
      return location.pathname === '/' || location.pathname === '/home';
    }
    return location.pathname === path;
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-lg z-50">
      <div className="grid grid-cols-5 h-16">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center justify-center transition-all duration-200 ${
              item.isMain
                ? 'bg-gradient-to-t from-[#0056A6] to-[#0066CC] text-white rounded-t-2xl mx-2 -mt-2 shadow-lg'
                : isActive(item.path)
                ? 'text-[#0056A6]'
                : 'text-gray-400 hover:text-gray-600'
            }`}
          >
            <i 
              className={`${
                isActive(item.path) ? item.activeIcon : item.icon
              } text-xl mb-1 ${item.isMain ? 'text-2xl' : ''}`}
            ></i>
            <span className={`text-xs font-medium ${item.isMain ? 'text-xs' : ''}`}>
              {item.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
